import * as React from 'react';

import {LoadingPage} from '../../../loading-page/loading-page';

import {AddablePeople} from './addable-people';
import type {AddablePerson} from './addable-people';
import {AddedContacts} from './added-contacts';
import type {Contact} from './added-contacts';

import styles from './company-people.module.css';

const SETTINGS_HTML_URL_PATH = '/email-marketing/visitors/settings';

export type Person = {
    id: string;
    name: string;
    hasPhone: boolean;
    hasEmail: boolean;
    hasLinkedinUrl: boolean;
    location: string | null | undefined;
    jobTitle: string | null | undefined;
    position: string | null | undefined;
    contact:
        | {
              htmlUrlPath: string;
              phone: string | null | undefined;
              email: string | null | undefined;
          }
        | null
        | undefined;
};

type Props = {
    people: Person[] | null | undefined;
    selectedPersonIds: string[];
    updateSelectedPersonIds: (personId: string) => void;
    offsetHeightRefs: any[];
    onExpandPersonDetails: (personId: string) => void;
    onClose: () => void;
};

export function CompanyPeople(props: Props) {
    const [containerHeight, setContainerHeight] = React.useState<string>('100%');

    const containerRef = React.useRef(null);

    React.useEffect(() => {
        // Timeout necessary to get accurate ref values, unclear why useLayoutEffect isn't working as it should here
        setTimeout(() => {
            let heightOffset = 0;
            props.offsetHeightRefs.forEach((ref) => {
                if (ref.current) {
                    heightOffset += ref.current.clientHeight;
                }
            });

            const updatedContainerHeight = `calc(100% - ${heightOffset}px)`;
            if (containerRef.current && containerHeight !== updatedContainerHeight) {
                setContainerHeight(updatedContainerHeight);
            }
        }, 50);
    }, [props.offsetHeightRefs, containerHeight]);

    const addedContacts: Contact[] = [];
    const addablePeople: AddablePerson[] = [];
    if (props.people) {
        props.people.forEach((person) => {
            if (person.contact) {
                addedContacts.push({
                    id: person.id,
                    name: person.name,
                    location: person.location,
                    jobTitle: person.jobTitle,
                    position: person.position,
                    htmlUrlPath: person.contact.htmlUrlPath,
                    email: person.contact.email,
                    phone: person.contact.phone,
                });
            } else {
                addablePeople.push({
                    id: person.id,
                    name: person.name,
                    location: person.location,
                    jobTitle: person.jobTitle,
                    position: person.position,
                    hasEmail: person.hasEmail,
                    hasPhone: person.hasPhone,
                    hasLinkedinUrl: person.hasLinkedinUrl,
                });
            }
        });
    }

    return (
        <div
            ref={containerRef}
            style={{height: containerHeight}}
            className={styles['company-people-container']}
        >
            {props.people ? (
                <div className={styles['list-container']}>
                    <AddedContacts contacts={addedContacts} />
                    {!addablePeople.length && addedContacts.length ? null : (
                        <AddablePeople
                            people={addablePeople}
                            selectedPersonIds={props.selectedPersonIds}
                            updateSelectedPersonIds={props.updateSelectedPersonIds}
                            onClickName={props.onExpandPersonDetails}
                            onClose={props.onClose}
                            adjustFiltersUrl={SETTINGS_HTML_URL_PATH}
                        />
                    )}
                </div>
            ) : (
                <LoadingPage padding={0} />
            )}
        </div>
    );
}
